import { toast } from 'react-toastify';
import * as ActionTypes from '../../constants/actiontypes/funecap/teleconseillers';
import * as ActionTypesAuth from '../../constants/actiontypes/auth';
import * as Loadings from '../../constants/loadings/funecap/teleconseillers';
import * as R from 'ramda';
import BackofficeUser from '../../constants/models/backofficeUser';
import * as TextUser from '../../constants/toasterText/user';
import * as TextClient from '../../constants/toasterText/backofficeClients';
import { pageLimit } from '../../constants/paginations/paginationLimit';

const toastConf = { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 };


const TeleconseillersReducer = (state = {
    isLoading: [],
    items: undefined,
    isDeletingClient: false,
    resetPasswordPhoneNumber: false,
    nextPage: true,
    totalPages: 0,
    totalRecords: 0,
    currentPage: 0,
    globalFilters: {
        order: {
            column: "lastName",
            asc: false
        },
        role: undefined,
        search: "",
    }


}, action) => {
    switch (action.type) {

        case ActionTypes.FETCH_TELECONSEILLERS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_TELECONSEILLERS)) {
                state.isLoading = state.isLoading.concat(Loadings.FETCHING_TELECONSEILLERS);
            }

            return { ...state };

        case ActionTypes.FETCH_TELECONSEILLERS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_TELECONSEILLERS);

            //action.data.length < pageLimit
            if ((action.data.pageNumber + 1) === action.data.totalPages) {
                state.nextPage = false;
            } else {
                state.nextPage = true;
            }

            if (state.items) {
                const moreItems = action.data.items.map(user => new BackofficeUser(user));
                state.items = [...moreItems];
            } else {

                state.items = action.data.items.map(user => new BackofficeUser(user));
            }
            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;

            return { ...state };

        case ActionTypes.FETCH_TELECONSEILLERS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_TELECONSEILLERS);
            return { ...state };

        case ActionTypes.DELETE_TELECONSEILLER_REQUEST:
            if (!state.isLoading.includes(Loadings.DELETING_TELECONSEILLERS)) {
                state.isLoading = state.isLoading.concat(Loadings.DELETING_TELECONSEILLERS);
            }
            return { ...state };

        case ActionTypes.DELETE_TELECONSEILLER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.DELETING_TELECONSEILLERS);
            state.items = state.items.filter(c => c.id !== action.userId);
            toast.success(TextClient.clientDeleteSuccess, toastConf);
            return { ...state };

        case ActionTypes.DELETE_TELECONSEILLER_FAILURE:
            toast.error(TextClient.clientDeleteFailed, toastConf);
            state.isLoading = state.isLoading.filter(l => l !== Loadings.DELETING_TELECONSEILLERS);
            return { ...state };

        case ActionTypes.RESET_PASSWORD_SUCCESS:
            state.resetPasswordPhoneNumber = true;
            toast.success(TextClient.emailPasswordRecoveredSucess, toastConf);
            return { ...state };

        case ActionTypes.RESET_PASSWORD_FAILURE:
            state.resetPasswordPhoneNumber = false;
            toast.error(TextClient.emailPasswordRecoveredFailed, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_TELECONSEILLER_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_TELECONSEILLERS)) {
                state.isLoading = state.isLoading.concat(Loadings.UPDATING_TELECONSEILLERS);
            }
            return { ...state };

        case ActionTypes.UPDATE_TELECONSEILLER_SUCCESS:
            state.items = state.items.map((user) => {
                if (user.id === action.data.id) {
                    return new BackofficeUser(action.data);
                }
                return user;
            });

            state.isLoading = state.isLoading.filter(l => l !== Loadings.UPDATING_TELECONSEILLERS);
            toast.success(TextUser.dataUpdatedSuccess, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_TELECONSEILLER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.UPDATING_TELECONSEILLERS);
            toast.error(TextUser.dataUpdateFailed, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_TELECONSEILLER_SECURITY_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_TELECONSEILLER_SECURITY_REQUEST)) {
                state.isLoading = state.isLoading.concat(Loadings.UPDATING_TELECONSEILLER_SECURITY_REQUEST);
            }
            return { ...state };

        case ActionTypes.UPDATE_TELECONSEILLER_SECURITY_SUCCESS:
            if (!R.isNil(action.user.newPhoneNumber)) {
                state.clients = state.clients.map((client) => {
                    if (client.id === action.userId) {
                        client.phoneNumber = action.user.newPhoneNumber;
                        return client;
                    }
                    return client;
                });

            }
            if (!R.isNil(action.user.newEmail)) {
                state.clients = state.clients.map((client) => {
                    if (client.id === action.userId) {
                        client.email = action.user.newEmail;
                        return client;
                    }
                    return client;
                });

            }

            state.isLoading = state.isLoading.filter(c => c !== Loadings.UPDATING_TELECONSEILLER_SECURITY_REQUEST);
            toast.success(TextUser.updateSecuritySuccess, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_TELECONSEILLER_SECURITY_FAILURE:
            state.isLoading = state.isLoading.filter(c => c !== Loadings.UPDATING_TELECONSEILLER_SECURITY_REQUEST);
            toast.error(TextUser.udpateSecurityFailed, toastConf);
            return { ...state };

        case ActionTypes.CREATE_TELECONSEILLER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.CREATING_TELECONSEILLERS);
            state.items = [...state.items, new BackofficeUser(action.data)];
            toast.success(TextClient.clientCreationSuccess, toastConf);
            return { ...state };

        case ActionTypes.CREATE_TELECONSEILLER_FAILURE:
            state.isLoading = state.isLoading.filter(c => c !== Loadings.CREATING_TELECONSEILLERS);
            toast.error(TextClient.clientCreationFailed, toastConf);
            return { ...state };


        case ActionTypes.SET_TELECONSEILLER_FILTER:
            const newState = { ...state.globalFilters, ...action.data };
            state.globalFilters = newState;
            return { ...state };

        default:
            return state;
    }
};
export default TeleconseillersReducer;